import { ThunkAction } from "@reduxjs/toolkit";
import { Dispatch } from "redux";

import getUser from "@/api/requests/getUser";
import publicConfig from "@/config/public";
import { getDomainCountryCode } from "@/redux/selectors/config";
import {
  changeMenuPreference,
  loadUser as loadUserAction,
} from "@/redux/slices/user";
import { AppState } from "@/redux/store";
import { setClientSideCookie } from "@/utils/cookies";
import { menuTypeCookieName, validatedMenuType } from "@/utils/menuTypeUtils";

export const loadUser = async (
  domainCountryCode: string,
  dispatch: Dispatch,
) => {
  const user = await getUser(domainCountryCode);

  dispatch(loadUserAction(user));
};

export interface UserPreferenceChangeAction {
  type: typeof changeMenuPreference.type;
  payload: string;
}

export const setUserMenuPreference =
  (
    value: string,
  ): ThunkAction<void, AppState, unknown, UserPreferenceChangeAction> =>
  (dispatch, getState) => {
    const reduxState = getState();
    const countryCode = getDomainCountryCode(reduxState);
    const validCookieValue = validatedMenuType(value);

    if (validCookieValue) {
      setClientSideCookie(
        menuTypeCookieName,
        validCookieValue,
        countryCode === "CA"
          ? publicConfig.cookieDomainCa
          : publicConfig.cookieDomain,
      );

      dispatch(changeMenuPreference(value));
    }
  };
